const SERVICE = "kyc-service";

const setKycUser = async (api, body) =>
  api.setMethod().post().setService(SERVICE).setBody(body).process("/kyc");

const getKycUser = async (api) =>
  api.setMethod().get().setService(SERVICE).process("/user");

const updateKycUser = async (api, body) =>
  api.setMethod().put().setService(SERVICE).setBody(body).process("/user");

module.exports = {
  setKycUser,
  getKycUser,
  updateKycUser,
};
